import { eur } from "@/lib/api";
import { Card } from "@/components/common";
import { pct, num, signCls, signed } from "./helpers";

function Box({ label, value, cls = "text-slate-900", sub, testid }) {
  return (
    <Card className="p-4" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-wide text-slate-500">{label}</div>
      <div className={`text-xl font-bold tabular mt-1 ${cls}`}>{value}</div>
      {sub && <div className="text-[11px] text-slate-400 mt-0.5">{sub}</div>}
    </Card>
  );
}

export default function Kpis({ d }) {
  const t = d.totals, k = d.kpi, has = d.target.amount != null;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
        <Box testid="pv-kpi-conf" label="Lordo confermato" value={eur(t.entrate_conf)} sub={`${num(t.nights_conf)} notti confermate`} />
        <Box testid="pv-kpi-prev" label="Lordo previsto" value={eur(t.entrate_prev)} cls="text-violet-700" sub={`${num(t.nights_prev)} notti previste (confermato + pickup)`} />
        <Box testid="pv-kpi-spese" label="Spese + imprevisti 15%" value={eur(t.spese_prev + t.impr_prev)} sub={`di cui imprevisti ${eur(t.impr_prev)}`} />
        <Box testid="pv-kpi-comm" label="Commissioni agenzie" value={eur(t.commissioni || 0)} sub="incluse nel lordo, tolte dal netto" />
        <Box testid="pv-kpi-tasse" label="Tasse (TGST + Green Tax)" value={eur(t.tasse || 0)} sub="sul 30% del lordo e delle notti-ospite" />
        <Box testid="pv-kpi-netto" label="Netto previsto" value={eur(t.netto_prev)} cls={signCls(t.netto_prev)} sub={`netto solo confermato ${eur(t.netto_conf)}`} />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        <Box testid="pv-kpi-ytd" label="Netto da inizio anno" value={eur(k.ytd_netto)} cls={signCls(k.ytd_netto)} sub={has ? `obiettivo a oggi ${eur(k.ytd_target)}` : "mesi chiusi + in corso"} />
        <Box testid="pv-kpi-scost" label="Scostamento a oggi" value={has ? signed(k.scostamento) : "—"} cls={has ? signCls(k.scostamento) : "text-slate-400"} sub={has ? pct(k.scostamento_pct) : "imposta un obiettivo"} />
        <Box testid="pv-kpi-scost-end" label="Scostamento previsto a fine anno" value={has ? signed(t.netto_prev - d.target.amount) : "—"} cls={has ? signCls(t.netto_prev - d.target.amount) : "text-slate-400"} sub={has ? `netto previsto vs obiettivo ${eur(d.target.amount)}` : ""} />
        <Box testid="pv-kpi-required" label="Lordo necessario per l'obiettivo" value={has ? eur(k.required_gross) : "—"} sub={has ? (k.gap_gross > 0 ? `mancano ${eur(k.gap_gross)} sul previsto` : "obiettivo coperto dal previsto") : "obiettivo + spese + imprevisti"} cls={has && k.gap_gross > 0 ? "text-rose-600" : "text-slate-900"} />
        <Box testid="pv-kpi-nights" label="Notti mancanti stimate" value={has ? num(k.notti_mancanti) : "—"} sub={has ? `a ADR medio ${eur(k.adr_medio)}` : ""} cls={has && k.notti_mancanti > 0 ? "text-rose-600" : "text-emerald-700"} />
      </div>
    </div>
  );
}
